import { Perimeter } from 'vue-kindergarten';
import _find from 'lodash/find';

/* eslint-enable */

export default class BasePerimeter extends Perimeter {
  isAdmin() {
    if (!this.child.roles.length) {
      return false;
    }
    return !!_find(this.child.roles, { name: 'admin' });
  }

  isManager() {
    if (!this.child.roles.length) {
      return false;
    }
    return !!_find(this.child.roles, { name: 'manager' });
  }

  isVertrieb() {
    if (!this.child.roles.length) {
      return false;
    }
    return !!_find(this.child.roles, { name: 'vertrieb' });
  }

  isCreator(entity) {
    if (entity) {
      return this.child.id === entity.user_id;
    }
    return true;
  }

  isBaseRole() {
    return !!_find(this.child.roles, { name: 'base' });
  }
}



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/BasePerimiter.js